/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Nullable } from '../../constants/types'

export const FullScreenUtils = {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    /**
     * request full screen API for multiple, non-spec named browser implementations on specified element
     * @param {Nullable<HTMLElement>}
     */
    async activateFullScreenMode(el: Nullable<HTMLElement>): Promise<void> {
        if (el) {
            if (el.requestFullscreen) {
                // W3C spec
                return el.requestFullscreen().catch((e) => console.error(e))
            } else if ((el as any).mozRequestFullScreen) {
                // Firefox
                return (el as any).mozRequestFullScreen()
            } else if ((el as any).webkitRequestFullscreen) {
                // Safari
                return (el as any).webkitRequestFullscreen()
            } else if ((el as any).msRequestFullscreen) {
                // IE/Edge
                return (el as any).msRequestFullscreen()
            }
        }
    },

    /**
     *  exit full screen API for multiple, non-spec named browser implementations on document
     */
    async deactivateFullscreen(): Promise<void> {
        if (document.exitFullscreen) {
            return document.exitFullscreen().catch((e) => console.error(e))
        } else if ((document as any).mozCancelFullScreen) {
            return (document as any).mozCancelFullScreen()
        } else if ((document as any).webkitExitFullscreen) {
            return (document as any).webkitExitFullscreen()
        }
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */
}
